export default __webpack_public_path__ + "static/media/wordpress.2812f0b1.gif";